<template>
  <div>
    <div class="wrapper">
      <app-the-header></app-the-header>
      <router-view></router-view>
      <app-the-footer></app-the-footer>
    </div>
  </div>
</template>

<script>
  import TheHeader from './components/TheHeader.vue';
  import TheFooter from './components/TheFooter.vue';

  export default {
    components: {
      appTheHeader: TheHeader,
      appTheFooter: TheFooter
    }
  }
</script>

<style lang="scss">
  @import "./scss/main.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue